import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

export const collection = 'tokenCreation'

export const schema = new schemas.Entity(collection)

export type CreateTokenPayloadType = {
  code: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, body: CreateTokenPayloadType) =>
    callApi(`${apiBase}/public-api-tokens/create`, schema, {
      method: 'POST',
      body,
    })
